export default "__VITE_ASSET__zvGStu0L__"